<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-28 13:50:41
 * @LastEditors: shayne
 * @LastEditTime: 2023-03-31 15:32:04
 * @FilePath: /privacy-web/src/components/The/TheFooterNavigation.vue
-->
<template>
  <div class="menus-main" :class="{ 'menus-main-mobile': isMobile }">
    <div @click="to(item)" class="menus-item" v-for="item in menusList" :key="item.key">
      {{ item.name }}
    </div>
  </div>
</template>
<script>
  export default {
    name: 'TheFooterNavigation',
    data() {
      return {
        menusList: [
          {
            path: 'https://about.ke.com/public/introduce/index.html',
            name: '关于我们',
            key: 'home-page'
          },
          {
            path: '/privacy-policy',
            name: '使用贝壳前必读',
            key: 'privacy-policy'
          },
          {
            path: '/privacy-manage',
            name: `@贝壳${new Date().getFullYear()}`,
            key: 'privacy-manage'
          }
        ]
      };
    },
    computed: {
      activeIndex() {
        return this.$route.path;
      }
    },
    methods: {
      to(item) {
        if (item.key === 'home-page') {
          window.open(item.path, '_blank');
        } else if (item.key === 'privacy-policy') {
          if (this.$route.path === '/privacy-policy') {
            document.querySelector('.el-main')?.scrollTo(0, 0);
            return;
          }
          this.$router.push(item.path);
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .menus-main {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: calc($multiple * 117px);
    height: calc($multiple * 61px);
    font-size: calc($multiple * 14px);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 1px;
    line-height: calc($multiple * 61px);
    .menus-item {
      cursor: pointer;
    }
  }
  .menus-main-mobile {
    gap: 0.9rem;
    height: 3.17rem;
    font-size: 0.61rem;
    padding: 0.8rem 1.02rem 0;
    line-height: 3.17rem;
    justify-content: space-between;
  }
</style>
